import { Component, computed, inject, input, signal } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import {
  FormFieldLabels,
  TextFormFieldOptions,
} from '../../../form-field.types';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { FormFieldService } from '../../../services/form-field/form-field.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { ErrorStateMatcher } from '@angular/material/core';

@Component({
  selector: 'app-text-form-field',
  imports: [
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatTooltipModule,
    MatIconModule,
  ],
  templateUrl: './text-form-field.component.html',
  styleUrl: './text-form-field.component.scss',
})
export class TextFormFieldComponent {
  private formFieldService = inject(FormFieldService);

  name = input('');
  path = input<string>();
  labels = input<FormFieldLabels>();
  options = input<TextFormFieldOptions>();
  errorStateMatcher = input<ErrorStateMatcher>({
    isErrorState: control => !!(control?.touched && control?.errors),
  });

  formGroup = this.formFieldService.formGroup;
  control = computed(() => {
    const path = this.path() ?? this.name();
    const formGroup = this.formGroup();
    return formGroup?.get(path) as FormControl;
  });

  required = computed(() => !!this.options()?.required);
  label = computed(() => this.labels()?.label);
  placeholder = computed(() => this.labels()?.placeholder ?? '');
  help = computed(() => this.labels()?.help);
  error = this.formFieldService.controlErrorMessage(this.name, this.path);
  isPassword = computed(() => this.options()?.inputType === 'password');
  type = computed(() => {
    const suppliedType = this.options()?.inputType;
    const showPassword = this.showPassword();
    const isPassword = this.isPassword();
    if (isPassword) {
      return showPassword ? 'text' : 'password';
    }
    return suppliedType ?? 'text';
  });
  min = computed(() => this.options()?.min);
  max = computed(() => this.options()?.max);
  step = computed(() => this.options()?.step);
  showPassword = signal(false);

  onShowPassword() {
    this.showPassword.set(!this.showPassword());
  }
}
